<template>
  <div>
    <h5 class="my-5">Login</h5>
    <div class="row">
      <input
        type="text"
        class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        placeholder="Username (email address)"
        v-model="username"
      >
      <input
        type="password"
        class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        placeholder="Password"
        v-model="password"
      >
      <div v-show='error' style='color:red;' class="col-md-4 offset-md-4 col-xs-12 my-2 px-2">
        {{error}}
      </div>
    </div>
    <div class='row'>
      <a class='col-md-4 offset-md-4 col-xs-12' v-bind:href="forgotPassUrl">Forgot Password?</a>
    </div>
    <div class="row">
      <div class="col-md-4 offset-md-4 mt-5">
        <button class="btn btn-primary" v-on:click="login">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
import auth from "../commons/auth.js";

export default {
  data: function() {
    return {

      forgotPassUrl:auth.uiHost+'/#/resetemail',
      username: "",
      password: "",
      error: ''
    };
  },
  methods: {
    login: async function() {
      try {
        let response = await auth.post("/login", {
          username: this.username,
          password: this.password
        });

        localStorage.token = response.data.token;
        http.loadToken();
        this.$router.push("/adminhome");
      } catch (err) {
        console.log("auth login err", err);
        this.error = "Login failed. Please try again.";
      }
    }
  }
};
</script>

<style>
</style>
